import * as Styled from './PunchupCompedTickets.styles';

import { useHistory, useParams } from 'react-router-dom';

import { IdParamsType } from 'utils/types';
import { PunchupCancelInviteModal } from './PunchupCancelInviteModal';
import { PunchupCompedTicketsTable } from './PunchupCompedTicketsTable';
import { PunchupSearch } from 'features/common/components/PunchupSearch';
import { PunchupShowDashboardPage } from 'features/common/components/Punchup/ShowDashboardPage/PunchupShowDashboardPage';
import { ROUTES } from 'features/routes';
import { Send, Upload } from 'lucide-react';
import { useDebounce } from 'utils/utils';
import { useCompedTicketsPage } from './hooks/useCompedTicketsPage';
import { useTranslation } from 'react-i18next';

export const PunchupCompedTickets = () => {
	const { t } = useTranslation();
	const { push } = useHistory();
	const { id } = useParams<IdParamsType>();

	const {
		setSearchText,
		compedTicketsQueryObject,
		showCancelModal,
		closeCancelModal,
		openCancelModal,
		onCancelInvite,
	} = useCompedTicketsPage();

	const searchDebounce = useDebounce(setSearchText);

	const onSendTicket = () => push(ROUTES.SEND_TICKETS.replace(':id', id));

	const onUploadCSV = () => window.parent.postMessage({ action: 'event-comp-csv' }, '*');

	return (
		<PunchupShowDashboardPage pageName="Comped Tickets">
			<Styled.Container>
				<Styled.FiltersContainer>
					<PunchupSearch
						width="300px"
						onChange={(e) => searchDebounce(e.target.value)}
						placeholder={t('search-email-or-name')}
					/>

					<Styled.ButtonsContainer>
						<Styled.SendTicketsButton onClick={onSendTicket} aria-label={t('comped-tickets-send-tickets')}>
							<Styled.MobileIcon>
								<Send size={18} />
							</Styled.MobileIcon>
							<Styled.DesktopLabel>{t('comped-tickets-send-tickets')}</Styled.DesktopLabel>
						</Styled.SendTicketsButton>
						<Styled.SendTicketsButton onClick={onUploadCSV} aria-label={t('comped-tickets-upload-csv')}>
							<Styled.MobileIcon>
								<Upload size={18} />
							</Styled.MobileIcon>
							<Styled.DesktopLabel>{t('comped-tickets-upload-csv')}</Styled.DesktopLabel>
						</Styled.SendTicketsButton>
					</Styled.ButtonsContainer>
				</Styled.FiltersContainer>

				<PunchupCompedTicketsTable
					compedTicketsQueryObject={compedTicketsQueryObject}
					openCancelModal={openCancelModal}
				/>
			</Styled.Container>

			{showCancelModal.show && (
				<PunchupCancelInviteModal
					showModal={showCancelModal.show}
					closeModal={closeCancelModal}
					modalInfo={{
						modalTitle: t('comped-ticket-cancel-invite-modal-title'),
						modalMessage: t('comped-ticket-cancel-invite-modal-description'),
						onDelete: onCancelInvite,
					}}
				/>
			)}
		</PunchupShowDashboardPage>
	);
};
